import * as React from 'react'
import { NavLink, Link } from 'react-router-dom'
import styled from 'styled-components'
import shield from '../images/shield.svg'

const Header = styled.header`
	background-color: #26262B;
	box-shadow: 0 3px 10px rgba(0,0,0,.4);
	color: #ccc;
	padding: 8px 16px;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	a, a:visited {
		color: #ccc;
		text-decoration: none;
		transition: 0.5s all ease;
	}

	nav a {
		margin-left: 24px;
	}

	a:hover {
		color: #999;
	}

	nav {
		display: flex;
	}

	img {
		display: none;
		width: 60px;
		height: 60px;
	}

	@media (min-width: 500px) {
		justify-content: space-between;

		img {
			display: block;
		}
  }
`

const Nav = () => (
	<Header>
		<Link to="/"><img src={ shield } alt='Logo' /></Link>
		<nav>
			<NavLink exact to="/">Database</NavLink>
	    <NavLink to="/team">Team</NavLink>
			<NavLink to="/archive">Archive</NavLink>
		</nav>
	</Header>
)

export default Nav
